import React, { useState, useEffect } from 'react'

import { useConfig } from '@peracto/peracto-config'

import PrivateRoute from '../components/PrivateRoute'

export function useRoutes() {
    const [routes, setRoutes] = useState([])

    const config = useConfig()

    useEffect(() => {
        let routes = []

        config.get('modules', []).forEach(mod => {
            let m = mod

            if (typeof m === 'function') {
                m = m()
            }

            routes = routes.concat(
                m.routes.map((route, i) => <PrivateRoute key={`${route.path}_${i}`} {...route} />)
            )
        })

        setRoutes(routes)
    }, [])

    return routes
}
